import { render } from "./sMTBResult.vue?vue&type=template&id=118af585&scoped=true"
import script from "./sMTBResult.vue?vue&type=script&lang=js"
export * from "./sMTBResult.vue?vue&type=script&lang=js"

import "./sMTBResult.vue?vue&type=style&index=0&id=118af585&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118af585"]])

export default __exports__